/* Generated attribution v1: do not edit directly. */
(function(){
const STORAGE_KEY='dv_chatgpt_attribution_v1';
const MAX_AGE=30*86400000;
const UTM_KEYS=['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
function cleanTouch(input,now) {
  if(!input || typeof input!=='object')return null;
  const at=Date.parse(input.captured_at);
  if(!Number.isFinite(at)||at>now+300000||now-at>MAX_AGE)return null;
  const out={captured_at:new Date(at).toISOString(),path:typeof input.path==='string'?input.path.slice(0,500):'/',oppref:null};
  for(const key of UTM_KEYS)out[key]=typeof input[key]==='string'?input[key].slice(0,200):null;
  if(typeof input.oppref==='string'&&input.oppref.length<=2048)out.oppref=input.oppref||null;
  const source=(out.utm_source||'').toLowerCase(),medium=(out.utm_medium||'').toLowerCase();
  out.channel=(source==='chatgpt'||source==='chatgpt.com')&&medium==='paid'?'chatgpt_paid':source==='chatgpt.com'&&medium==='feed'?'chatgpt_catalog':out.oppref&&!source?'chatgpt_click_identifier':'other_or_unknown';
  return out;
}
function cleanState(input,now) {
  if(!input||typeof input.association_id!=='string'||!/^[A-Za-z0-9_-]{1,128}$/.test(input.association_id))return null;
  const out={version:1,association_id:input.association_id,first_touch:cleanTouch(input.first_touch,now),latest_touch:cleanTouch(input.latest_touch,now),last_paid:cleanTouch(input.last_paid,now)};
  if(out.last_paid&&!['chatgpt_paid','chatgpt_click_identifier'].includes(out.last_paid.channel))out.last_paid=null;
  return out.first_touch||out.latest_touch||out.last_paid?out:null;
}
function updateTouch(old,href,now,nonce) {
  let state=cleanState(old,now);
  let url;try{url=new URL(href);}catch{return state;}
  if(!['divinch.us','www.divinch.us','bf5af3-f0.myshopify.com'].includes(url.hostname))return state;
  if(!UTM_KEYS.some(k=>url.searchParams.get(k))&&!url.searchParams.get('oppref'))return state;
  const raw={captured_at:new Date(now).toISOString(),path:url.pathname,oppref:url.searchParams.get('oppref')};
  for(const key of UTM_KEYS)raw[key]=url.searchParams.get(key);
  const item=cleanTouch(raw,now);
  if(!item)return state;
  if(state?.latest_touch && JSON.stringify({...state.latest_touch,captured_at:''})===JSON.stringify({...item,captured_at:''}))return state;
  state=state||{version:1,association_id:nonce,first_touch:null,latest_touch:null,last_paid:null};
  state.first_touch=state.first_touch||item;state.latest_touch=item;
  if(['chatgpt_paid','chatgpt_click_identifier'].includes(item.channel))state.last_paid=item;
  return cleanState(state,now);
}

function startStorefront(env){
 let queue=Promise.resolve(),lastWritten='',everStored=false;
 const keys=['association','record','oppref','utm_source','utm_medium','utm_campaign','utm_content','utm_term','test'].map(k=>'__dv_cg_'+k);
 function allowed(){try{const p=env.Shopify?.customerPrivacy;return p?.analyticsProcessingAllowed()===true&&p.marketingAllowed()===true&&p.saleOfDataAllowed()!==false;}catch{return false;}}
 async function run(){
  try{
   const raw=env.localStorage.getItem(STORAGE_KEY);let old=null;try{old=JSON.parse(raw);}catch{}
   const ok=allowed();
   const diagnostic=new URL(env.location.href).searchParams.get('dv_cg_test');
   if(diagnostic==='0'&&old){
    for(const key of ['first_touch','latest_touch','last_paid']){
     const touch=old[key];
     if(touch?.oppref?.startsWith('internal-test-')&&touch?.utm_campaign?.startsWith('internal_attribution_qa_'))old[key]=null;
    }
   }
   if(!ok||diagnostic==='0')env.sessionStorage?.removeItem('dv_cg_test_v1');
   else if(diagnostic==='1')env.sessionStorage?.setItem('dv_cg_test_v1','1');
   const state=ok?updateTouch(old,env.location.href,Date.now(),env.crypto.randomUUID()):null;
   if(!state){env.localStorage.removeItem(STORAGE_KEY);if(!raw&&!everStored)return;}
   else {env.localStorage.setItem(STORAGE_KEY,JSON.stringify(state));everStored=true;}
   const attributes=Object.fromEntries(keys.map(k=>[k,'']));
   if(state){
    const selected=state.last_paid||state.latest_touch||state.first_touch;
    attributes.__dv_cg_association=state.association_id;attributes.__dv_cg_record=JSON.stringify(state);
    attributes.__dv_cg_test=env.sessionStorage?.getItem('dv_cg_test_v1')==='1'?'1':'';
    for(const k of ['oppref','utm_source','utm_medium','utm_campaign','utm_content','utm_term'])attributes['__dv_cg_'+k]=selected[k]||'';
   }
   const body=JSON.stringify({attributes});if(body===lastWritten)return;
   const result=await env.fetch((env.Shopify.routes?.root||'/')+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body});
   if(result.ok)lastWritten=body;
  }catch{/* Preserve checkout behavior; retry on the next lifecycle event. */}
 }
 const refresh=()=>queue=queue.then(run,run);
 env.document.addEventListener('visitorConsentCollected',refresh);
 env.addEventListener('pageshow',refresh);
 // Page navigation and consent drive persistence. Checkout buttons are never blocked.
 if(env.Shopify?.customerPrivacy)refresh();
 else env.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.2'}],error=>{if(!error)refresh();});
 return {refresh};
}

startStorefront(window);
})();
